import { subTableOrder } from "../utils/Enum";
import { fetchPersonnelByPid } from "./PersonnelApiFetch";
import {getAllActivitiesAndBreakdownsByPid, sortActivitiesByShift} from "./ActivitiesApiFetch";
import { fetchDrillingByPid } from "./DrillingApiFetch";
import { fetchBreakdownsByPid } from "./BreakdownsApiFetch";
import { fetchCasingByPid } from "./CasingApiFetc";
import { fetchConsumableByPid } from "./ConsumablesApiFetch";
import { fetchBitsByPid } from "./BitsApiFetch";
import { fetchDHSurveyByPid } from "./DHSurveyApiFetch";
import { fetchGroutingByPid } from "./GroutingApiFetch";
import { fetchRigMoveByPid } from "./RigMovesApiFetch";
import { fetchRigServiceByPid } from "./RigServiceApiFetch";
import { fetchPackingByPid } from "./PackingApiFetch";
import { fetchWaterByPid } from "./WaterApiFetch";
import { fetchFuelByPid } from "./FuelApiFetch";
import {fetchPowerPackByPid} from "./PowerPackApiFetch";
import {fetchSafetyDataByPid} from "./SafetyDataApiFetch";
import {fetchTrainingByPid} from "./TrainingApiFetch";

export const fetchAllSubTableData = async (pid: number, aid: number = -1, isDayShift: boolean = true ) => {
    try {
        const personnel = await fetchPersonnelByPid(pid, aid);
        const activitiesAndBreakdowns = await getAllActivitiesAndBreakdownsByPid(pid, aid);
        const activities = sortActivitiesByShift(activitiesAndBreakdowns, isDayShift);
        const drilling = await fetchDrillingByPid(pid, aid);
        /*const breakdowns = await fetchBreakdownsByPid(pid, aid);*/
        const consumables = await fetchConsumableByPid(pid, aid);
        const casing = await fetchCasingByPid(pid, aid);
        const bits_and_reamers = await fetchBitsByPid(pid, aid);
        const dhsurvey = await fetchDHSurveyByPid(pid, aid);
        const grouting = await fetchGroutingByPid(pid, aid);
        const rig_moves = await fetchRigMoveByPid(pid, aid);
        const rig_service = await fetchRigServiceByPid(pid, aid);
        const packing = await fetchPackingByPid(pid, aid);
        const water = await fetchWaterByPid(pid, aid);
        const fuel = await fetchFuelByPid(pid, aid);
        const power_pack = await fetchPowerPackByPid(pid, aid);
        const safety_data = await fetchSafetyDataByPid(pid, aid);
        const training = await fetchTrainingByPid(pid, aid);

        return {
            personnel,
            activities,
            drilling,
            /*breakdowns,*/
            consumables,
            casing,
            bits_and_reamers,
            dhsurvey,
            grouting,
            rig_moves,
            rig_service,
            packing,
            water,
            fuel,
            power_pack,
            safety_data,
            training,
        };

    } catch (error) {
        console.error("Error fetching sub-table data:", error);
        return {
            personnel: [],
            activities: [],
            drilling: [],
            /*breakdowns: [],*/
            consumables: [],
            casing: [],
            bits_and_reamers: [],
            dhsurvey: [],
            grouting: [],
            rig_moves: [],
            rig_service: [],
            packing: [],
            water: [],
            fuel: [],
            power_pack: [],
            safety_data: [],
            training: [],
        };
    }
};

export const getFilteredTables = (tableData: { [key: string]: any[] }) => {
    return Object.entries(tableData)
        .filter(([_, data]) => data.length > 0)
        .map(([tableName]) => subTableOrder[tableName]);
};
